import { render, staticRenderFns } from "./painelclassesExportacao.vue?vue&type=template&id=3ad363c8&"
import script from "./painelclassesExportacao.vue?vue&type=script&lang=js&"
export * from "./painelclassesExportacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports